import { useCallback, useState } from 'react';

const key = 'ora-is-presentation-mode?';

export const usePresentationMode = () => {
  const [presentationMode, setPresentationMode] = useState(localStorage.getItem(key) === 'false');

  const handleSetPresentationMode = useCallback((newValue: boolean) => {
    localStorage.setItem(key, newValue ? 'false' : 'true');
    setPresentationMode(newValue);
  }, []);

  return [presentationMode, handleSetPresentationMode] as const;
};
